import React, { Children } from 'react';

export const childrenGetter = <T extends React.ComponentType[]>(
  children: React.ReactNode | React.ReactNode[],
  elementsArr: T,
) => {
  const childrenArr = Children.toArray(children);
  return childrenArr.reduce<React.ReactElement[]>((acc, el) => {
    if (React.isValidElement(el)) {
      const index = elementsArr.findIndex((comp) => comp === el.type);

      acc[index] = el;
    }
    return acc;
  }, []);
};
